import { MetricsPage } from '@repo/ui/features/superadmin';

export default function SuperAdminMetricsPage() {
  return (
    <div className="w-full py-6">
      <MetricsPage />
    </div>
  );
}
